import { render } from "./TransportationContractForm.vue?vue&type=template&id=5e65ddf2&scoped=true"
import script from "./TransportationContractForm.vue?vue&type=script&lang=js"
export * from "./TransportationContractForm.vue?vue&type=script&lang=js"

import "./TransportationContractForm.vue?vue&type=style&index=0&id=5e65ddf2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e65ddf2"

export default script